import * as yup from 'yup';
import { validateDateIsInThePast, validateDateIsReasonable } from '../functions';
import {
  archiveReasonOptions,
  archiveStatusOptions,
  SuccessfulROSReason,
  ROSUnderwayStatus,
  ROSCompleteStatus,
  ROSCompletedType,
  EmploymentEndedType,
} from '../../archiveParticipantsConstants';

const typeValidationMap = {
  [ROSCompletedType.value]: { reasons: [SuccessfulROSReason], statuses: [ROSCompleteStatus] },
  [EmploymentEndedType.value]: {
    reasons: archiveReasonOptions,
    statuses: [ROSUnderwayStatus, ...archiveStatusOptions],
  },
};

export const ArchiveHiredParticipantSchema = yup.object().shape({
  type: yup
    .string()
    .oneOf(['duplicate', 'employmentEnded', 'rosComplete'], 'Please select a type')
    .required('Please select a type'),
  reason: yup.string().when('type', {
    is: (type) => !!typeValidationMap[type],
    then: (schema) =>
      schema.test({
        test: function (value) {
          const type = this.parent.type;
          if (!typeValidationMap[type]) return true;
          return !!value && typeValidationMap[type].reasons.includes(value);
        },
        message: 'Please include a reason',
      }),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  status: yup.string().when('type', {
    is: (type) => !!typeValidationMap[type],
    then: (schema) =>
      schema.test({
        test: function (value) {
          const type = this.parent.type;
          if (!typeValidationMap[type]) return true;
          return !!value && typeValidationMap[type].statuses.includes(value);
        },
        message: 'Please include a status',
      }),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  endDate: yup
    .date()
    .test('is-present', 'Invalid entry. Date must be in the past.', validateDateIsInThePast)
    .test(
      'is-reasonable',
      'Invalid entry. Date must be after December 31st 1899.',
      validateDateIsReasonable,
    )
    .typeError('Invalid Date, must be in the format YYYY/MM/DD'),

  remainingInSectorOrRoleOrAnother: yup.string().when('type', {
    is: (type) => [EmploymentEndedType.value, ROSCompletedType.value].includes(type),
    then: (schema) =>
      schema
        .oneOf(['Yes', 'No', `I don't know`], `Must be either Yes, No or I don't know.`)
        .required("Must be either Yes, No or I don't know."),
  }),
  confirmed: yup.boolean().test('is-true', 'Please confirm', (v) => v === true),
});
